<template>
  <div class="product-card product-card--vertical@s">
    <a class="product-card__link" :href="product.url" :title="product.title">
      <div class="product-card__media-wrapper">
        <div class="product-card__media" v-if="product.featured_media" v-html="product.featured_media">
          <!-- Dimensione immagine 960x538 -->
        </div>
      </div>
      <div class="product-card__body">
        <p class="product-card__title">{{ product.name }}</p>
        <p class="product-card__text">{{ product.abstract }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
    },
  },
  watch: {
    items() {
      this.$nextTick(function () {
        document.querySelectorAll(".product-card__media img").forEach(img => {
          img.classList.add("lazyload");
        })
      })
    }
  },

}
</script>




// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/ProductCard.vue